import { Eye, EyeClosed } from '@phosphor-icons/react'
import React, { useState } from 'react'

import Input from '.'

function InputPassword ({ value, onChange, className, placeholder, autocomplete }: any) {
  const [showPassword, setShowPassword] = useState<boolean>(false)
  return (
    <div className={className} style={{ position: 'relative' }}>
      <Input
        className="pe-6"
        type={showPassword ? 'text' : 'password'}
        placeholder={placeholder}
        value={value}
        autocomplete={autocomplete}
        onChange={onChange}
      />
      <div
        className="addon"
        onClick={() => setShowPassword(!showPassword)}
        style={{
          position: 'absolute',
          right: '20px',
          top: '0',
          cursor: 'pointer',
          display: 'flex',
          height: '100%',
          alignItems: 'center'
        }}
      >
        {showPassword ? (
          <Eye size={24} color="#DDDDDC" />
        ) : (
          <EyeClosed size={24} color="#DDDDDC" />
        )}
      </div>
    </div>
  )
}

export default InputPassword
